import React from "react";
import { MapPin, Phone, Instagram, Clock } from "lucide-react";
import { Reveal, Label } from "@/components/Reveal";
import { LeadForm } from "@/components/LeadForm";
import { PHONE, ADDRESS, INSTAGRAM, WHATSAPP } from "@/data/content";

export default function Contact() {
  return (
    <>
      <section className="pt-40 pb-12 text-center max-w-5xl mx-auto px-5">
        <Label>Get In Touch</Label>
        <h1 className="text-5xl sm:text-6xl lg:text-7xl tracking-tighter mt-5">Visit Our Studio</h1>
      </section>

      <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-24 grid lg:grid-cols-2 gap-12">
        <Reveal>
          <div className="space-y-6">
            <div className="glass rounded-lg p-7 flex gap-4 transition-colors duration-500"><MapPin className="text-gold shrink-0" /><div><h4 className="text-lg">Address</h4><p className="text-white/70 text-sm mt-1">{ADDRESS}</p></div></div>
            <a href={`tel:${PHONE.replace(/ /g,'')}`} className="glass rounded-lg p-7 flex gap-4 transition-colors duration-500 hover:border-gold/50" data-testid="contact-phone"><Phone className="text-gold shrink-0" /><div><h4 className="text-lg">Call Us</h4><p className="text-white/70 text-sm mt-1">{PHONE}</p></div></a>
            <a href={`https://instagram.com/${INSTAGRAM}`} target="_blank" rel="noreferrer" className="glass rounded-lg p-7 flex gap-4 transition-colors duration-500 hover:border-gold/50" data-testid="contact-instagram"><Instagram className="text-gold shrink-0" /><div><h4 className="text-lg">Instagram</h4><p className="text-white/70 text-sm mt-1">@{INSTAGRAM}</p></div></a>
            <div className="glass rounded-lg p-7 flex gap-4 transition-colors duration-500"><Clock className="text-gold shrink-0" /><div><h4 className="text-lg">Hours</h4><p className="text-white/70 text-sm mt-1">Mon – Sun · 10:00 AM – 9:00 PM</p></div></div>
            <a href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noreferrer" className="btn-gold w-full text-center block" data-testid="contact-whatsapp">Chat on WhatsApp</a>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <LeadForm type="leads" testid="contact-form" title="Send Us a Message" sub="We'll get back to you within a few hours." cta="Send Message"
            extraFields={[{ name: "source", placeholder: "I'm interested in", type: "select", required: true, options: ["Salon Services", "Bridal Makeup", "Academy Courses", "General Enquiry"] }]} />
        </Reveal>
      </section>
    </>
  );
}
